import { PageContent } from "../pages/templates/PageLayout";

import Images from "../data/images";
import featureCards from "./featureCards";
import { MarketingButtons } from "../components/MarketingButtons";

const content: PageContent = {
  style: "dark",
  sections: [
    {
      type: "HeroSection",
      title: "The Right Asset.\nThe Right Context.\nEvery Time.",
      level: "h2",
      subtitle:
        "Your brand’s most important assets, beautifully organized and instantly available, without the chaos, in one brand management tool.",
      style: "darkGradient",
      image: {
        src: Images.Home.hero,
        alt: "Get the right asset, in the right context, every time.",
      },
      primaryButton: MarketingButtons.getStarted,
      secondaryButton: MarketingButtons.bookDemo,
      position: { mb: "none", pb: "xxxl" },
    },
    { type: "CustomerLogosSection", position: { mt: "-xl" } },
    {
      type: "MediaSection",
      title: "Build your brand",
      subtitle:
        "Use Lingo's easy to use DAM + customizable front end to publish an unlimited number of brand websites, no technical expertise needed.",
      image: {
        src: Images.Home.defineBrand,
        alt: "Slide 1",
      },
    },
    {
      type: "MediaSection",
      title: "Empower teams to create on their own",
      subtitle:
        "With Lingo, every team member will be able to find the file they need, in the format and size they need, all without needing your help.",
      layoutDirection: "image-left",
      image: {
        src: Images.Home.empowerTeams,
        alt: "Slide 1",
      },
    },
    {
      type: "MediaSection",
      title: "Always up to date",
      subtitle:
        "Lingo connects with the tools you use everyday so your assets are always up to date. Learn more about our Figma integration.",
      image: {
        src: Images.Home.upToDate,
        alt: "Slide 1",
      },
      primaryButton: {
        text: "Learn more about Figma & Lingo",
        link: "/integrations/figma",
      },
    },
    {
      type: "CardSection",
      title: "More features to help manage your brand",
      items: [
        featureCards.search,
        featureCards.customBranding,
        featureCards.fileConversions,
        featureCards.downloadRequests,
        featureCards.publicSharing,
        featureCards.customDomains,
      ],
      footerButton: {
        text: "View all features",
        buttonStyle: "outline",
        link: "/product/features",
      },
    },
    {
      type: "CtaSection",
      title: "Need help getting started?",
      body: "Our customer success team is here to help. With **Brand Setup**, we'll get your account imported, organized, and ready to distribute.",
      backgroundImage: Images.CTA.ctaImport,
    },
    {
      type: "ShowcaseSection",
      title: "Built for every brand, \nevery team, every industry",
      subtitle: "From brand libraries to product shots and sales decks, Lingo does it all.",
      primaryButton: {
        text: "See how other brands use Lingo",
        link: "/blog/brand-stories-denison-university",
      },
      image: {
        src: Images.Home.showcase,
        alt: "Slide 1",
      },
    },
  ],
};

export default content;
